/* eslint-disable */
export default {
  // actions
  actions: {
    addDamage: 'Hinzufügen',
    login: 'Anmeldung',
    select: 'Wählen',
    clear: 'Löschen',
    continue: 'Fortsetzen',
    cancel: 'Stornieren',
    import: 'Einführen',
    export: 'Export',
    selectFile: 'Datei aussuchen',
    search: 'Suche',
    save: 'Speichern'
  },
  downloadModal: {
    title: 'Datei wird heruntergeladen',
    text:
      'Das Herunterladen der Datei kann einige Minuten dauern. Verlassen Sie die Seite nicht.'
  },
  // component: furniture
  furniture: {
    title: 'Möbel',
    empty: {
      short: 'Fehlende Schadennummer',
      long:
        'Um Möbelschäden hinzufügen zu können, geben Sie die Schadennummer ein, und die Adresse.'
    },
    kindOfProperty: 'Art der Immobilie',
    kindOfPropertyOptions: {
      owner: 'Eigentümer',
      renter: 'Mieter'
    }
  },
  // component: warrantyLayout
  warrantyLayout: {
    registerSinister: 'Schaden speichern',
    newSinister: 'Neuer Schaden',
    registeredDamages:
      '0 x Position gespeichert | 1 x Position gespeichert | {count} x gespeicherter Positionen',
    modals: {
      newSinister: {
        title: 'Neuer Schaden. Bist du sicher ?',
        body: 'Alle Daten werden zurückgesetzt'
      }
    }
  },
  // component: warrantyRef
  warrantyRef: {
    sinisterRef: {
      literal: 'Schadennummer'
    },
    secondaryRef: {
      literal: 'Alternative Schadennummer (optional)'
    }
  },
  damageTypeCpi: {
    calendarLabel: {
      literal: 'Kaufdatum'
    },
    priceDamage: {
      literal: 'Kaufpreis'
    }
  },
  // component: warrantyProps
  warrantyProps: {
    aboutProperty: 'Ergänzende information',
    address: {
      literal: 'Adresse',
      placeholder: 'Adresse eingeben'
    },
    zipCode: {
      literal: 'Postleitzahl'
    },
    propertyType: {
      literal: 'Art der Inmobilie',
      options: {
        appartment: 'Wohnung',
        maison: 'Haus',
        local_commercial: 'Geschäftslokal'
      }
    },
    residentType: {
      literal: 'Art der Kunden',
      options: {
        propietarie: 'Inhaber',
        locataire: 'Mieter',
        propietarie_non_occupant: 'Vermieter'
      }
    },
    moreThanTwoYears: {
      literal: 'Alter des Eigentums',
      options: {
        less: 'Weniger als 2 jahre',
        more: 'Mehr als 2 jahre'
      }
    },
    map: {
      empty: {
        title: 'Keine Adresse',
        text: 'Können Sie eine gültige Adresse hinzufügen?'
      }
    },
    nameApplicant: {
      literal: `Name der Versicherten`,
      placeholder: 'Geben Sie den Namen ein'
    },
    formsList: 'Formen',
    fnolIdsList: 'Vertrag',
    userIdsList: 'Benutzertyp',
    buttonLink: {
      literal: `Siehe Benutzerlink`
    },
    modalLink: {
      buttonGenerateLink: 'Generieren Sie einen Link',
      buttonCancel: 'Abbrechen',
      title: 'Benutzerverknüpfung',
      alertMessage: 'Zusätzliche Informationen müssen ausgefüllt werden.',
      alertAction: 'Zusätzliche Informationen ausfüllen'
    },
    moreInfoModal: {
      buttonGenerateLink: 'Zusätzliche Informationen',
      buttonCancel: 'Abbrechen',
      title: 'Ergänzende Informationen',
      send: 'Senden',
      personalInfo: {
        title: '1. Persönliche Daten',
        name: 'Name',
        surname: 'Nachname',
        phone: 'Telefon',
        city: 'Stadt'
      },
      contractInfo: {
        title: '2. Vertrag',
        isValid: 'Ist der Vertrag gültig?',
        deductibles: 'Abzugsfähige Immobilien (€)',
        allowance: 'Freibetrag für Verschönerungen (€)',
        furnitureAllowance: 'Möbelzuschuss (€)',
        swimmingPool: 'Übernommene Option(en) - Schwimmbad',
        externalFittings: 'Abonnierte Option(en) - Externe Beschläge'
      },
      verifications: {
        title: '3. Überprüfungen',
        beforeSinister:
          'Kein aktueller Schadenfall an derselben Adresse mit derselben Deckung, der innerhalb von 15 Tagen vor oder nach diesem Schadenfall eingetreten ist',
        GaG: 'Name of Gré à gré',
        ren: 'Name of Ren',
        cause: 'Was war die Ursache für den Verlust?'
      },
      modalInformation: {
        title: 'Fehlende Informationen',
        literal: 'Um einen Link zu erstellen, müssen Sie zuerst die zusätzlichen Informationen ausfüllen.',
        literal2: 'Bitte füllen Sie diesen Abschnitt aus, bevor Sie fortfahren.',
        cancel: 'Abbrechen',
        completeInformation: 'Informationen ausfüllen',
      }
    },
    optionsUserType: {
      insured: 'Selfcare generisch',
      professional: 'Selfcare BillMA Profi',
      billma_insured: 'Selfcare BillMA Versichert',
      billma_agent: 'Selfcare Agent',
      billma_user: 'Selfcare BillMA',
      ren_professional: 'Selfcare REN Profi',
      ren_insured: 'Selfcare REN Versichert'
    },
    clientPhoneNumber: 'Telefonnummer',
    requiredFields: {
      title: 'Pflichtfelder',
      text: 'Pflichtfelder nicht ausgefüllt'
    }
  },
  // component: warrantySticky
  warrantySticky: {
    analyze: 'Analysieren',
    generateReport: 'Bericht erstellen',
    generateReportFnol: 'Schadensbeschreibung',
    materialListBtn: 'Liste der Materialien',
    smartReport: '',
    damageSummary: {
      title: 'Schadensbewertung',
      tableHead: {
        damages: 'Schäden',
        greAGre: 'Reparatur in Eigenleistung',
        reparationNetwork: 'Kostenaufstellung fiktive Abrechnung',
        reparationExcept: 'Durchnittlicher ortsüblicher Marktpreis'
      },
      tableSubHead: {
        embellishments: 'Verzierungen',
        immobilier: 'Unbeweglich',
        mobilier: 'Möbel'
      },
      tableMain: {
        manpowerHours: 'Arbeitszeit (Stunden)',
        manpowerCost: 'Arbeitszeit (Euro)',
        materialCost: 'Material',
        totalCost: 'Gesamt',
        priceWithoutTaxes: 'Steuern ex.',
        priceWithTaxes: 'Steuern inkl.'
      },
      description: {
        quantity: 'Menge'
      }
    },
    damageCounters: {
      gag: 'Eigenleistung',
      materials: 'Materialien und Möbel',
      estimatedTime: 'Geschätzte Zeit',
      authorizedNetworkRepair: 'Fiktive Abrechnung',
      artessianRepair: 'Ortsüblicher  Marktpreis',
      immediate: 'Sofort',
      difference: 'Unterschied',
      ensembleImage: 'Gesamtbild',
      presImage: 'Nahaufnahme Foto',
      totalPrice: 'Gesamtpreis'
    },
    manPower: {
      title: 'Änderung der Personalkosten',
      calculatePrice: 'Calculate cost',
      cancel: 'Cancel',
      setPrice: 'Legen Sie den Preis fest'
    },
    materialList: {
      title: 'Materialien und Arbeitszeit',
      manpowerTime: 'Arbeitszeit (stunden)',
      manpowerPrice: 'Arbeitszeit (€)',
      manpowerTitle: 'Arbeitszeit preis',
      materials: 'Materialien',
      gag: 'Zahlungsabwicklung',
      downloadPDF: 'PDF Herunterladen',
      cancel: 'Stornieren',
      send: 'Senden'
    }
  },
  // component: login
  login: {
    title: 'Meine Schäden',
    titleMA: 'MAValue',
    text: 'Ihr Schadenverwertungssystem',
    authenticationError: 'Login Fehler',
    authenticationBlock:
      'Login gesperrt, versuchen Sie es nochmals in ein paar Minuten',
    authenticationOk: 'Erfolgreicher Login',
    sso_processing: 'Identitätsprüfung läuft...',
    sso_wait: 'Bitte warten Sie einen Moment.',
    sso_error_title: 'Authentifizierungsfehler',
    sso_error_msg: 'Ein Fehler ist beim Login über SSO aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie Ihren Administrator.',
    inputs: {
      username: 'Nutzername',
      password: 'Passwort'
    },
    login: 'Anmeldung'
  },
  // component: error
  error: {
    title: 'MAValue',
    text: 'Die von Ihnen gesuchte Seite existiert nicht',
    btn: 'Zurück'
  },
  // component: adminLayout
  adminLayout: {
    modals: {
      import: {
        title: 'Parameter importieren',
        description:
          "Importieren Sie eine Datei, um Parameter zu ändern.'' Wenn der Parameter nicht vorhanden ist, wird er erstellt. Wenn der Parameter bereits vorhanden ist, werden die daten überschrieben."
      },
      export: {
        title: 'Parameter exportieren',
        description:
          'Wählen sie die Garantie-gruppe aus, für die Sie filtern möchten'
      }
    },
    filters: {
      warranty: 'Garantie-gruppe',
      subwarranty: 'Untergarantiegruppe'
    },
    notifications: {
      importedFile: {
        title: 'Datei importiert',
        body: 'Die Tabelle wurde hochgeladen'
      }
    }
  },
  // component: parameters (gagadmin)
  gagParameters: {
    title: 'Parameter',
    table: {
      paramName: 'Name des Parameters',
      paramValue: 'Wert des Parameters',
      customizable: 'Bearbeitbar'
    }
  },
  // component: repMat (gagadmin)
  gagRepMat: {
    title: 'Materialien reparieren',
    table: {
      rep_type_code: 'Code',
      rep_description: 'Beschreibung',
      rep_mat: 'Material',
      mat_format_sale: 'Verkaufsformat',
      dam_measure_unit: 'Maßeinheit',
      conv_unit_per_mat_measure: 'Umrechnungseinheit durch Materialmessung',
      mat_unit_price: 'Preis',
      is_hours: 'Nur Stunden',
      image: 'Bild'
    }
  },
  // component: zipCode (gagadmin)
  gagZipCode: {
    title: 'Postleitzahlen',
    table: {
      dept_code: 'Codes',
      zip_code_min: 'Minimale Postleitzahl',
      zip_code_max: 'Maximal Postleitzahl',
      country: 'Land',
      clean_cost: 'Kosten',
      displacement_hours: 'Fahrtstunden',
      coef: '*** coef',
      factmin: '*** factmin'
    }
  },
  // component: ajustage (gagadmin)
  gagAjustage: {
    title: 'Nach Kundenalter anpassen',
    table: {
      interval_age_start: 'Mindestalter',
      interval_age_end: 'Maximales Alter',
      age_coef: 'Koeffizient'
    }
  },
  // component: userLimits (gagadmin)
  gagUserLimits: {
    title: 'Grenzen',
    table: {
      user: 'Benutzer',
      hour_price_max_limit: 'Maximaler Preis pro Stunde',
      hour_price_min_limit: 'Mindestpreis pro Stunde'
    }
  },
  // component: salaries (gagadmin)
  gagSalaries: {
    title: 'Gehälter',
    table: {
      zip_code: 'Postleitzahl',
      csp: '*** csp',
      salary_hour: 'Preis pro Stunde'
    }
  },
  // component: parameters (admin)
  parameters: {
    title: 'Parameter',
    table: {
      paramName: 'Name des parameters',
      paramValue: 'Wert des parameters',
      customizable: 'Bearbeitbar',
      type: 'Art'
    }
  },
  // component: reparations (admin)
  reparations: {
    title: 'Reparationen',
    warrantyid: 'Garantiegruppe',
    subcategory: 'Unterkategorie',
    table: {
      repTypeCode: 'Reparaturcode',
      description: 'Beschreibung',
      type: 'Reparaturart',
      surfaceUnit: 'Maßeinheit',
      damagesType: 'Art des Schadens',
      priceCalcForm: 'Formular preisberechnung'
    }
  },
  // component: coefficients (admin)
  coefficients: {
    title: 'Preise',
    table: {
      repCodeType: 'Reparaturcode',
      description: 'Beschreibung',
      matSRen: 'Mat_s_RIK',
      coefMat: 'Coef_mat',
      coefMo: 'Coef_mo',
      price: 'Preis'
    }
  },
  // component: depreciations (admin)
  depreciations: {
    title: 'Abschreibung',
    table: {
      repTypeCode: 'Reparaturcode',
      description: 'Beschreibung',
      years: 'Jahre',
      depreciationPerc: 'Reparationsprozentsatz'
    }
  },
  // component: transversalCosts
  transversalcosts: {
    title: 'Kreuzkosten',
    table: {
      damageType: 'Art des Schadens',
      componentName: 'Komponentenname',
      description: 'Beschreibung',
      costFormat: 'Formatkosten',
      value: 'Wert'
    }
  },
  // component: small device modal
  smDevModal: {
    title: 'Ungültige bildschirmauflösung',
    text:
      'Den Inhalt, den Sie laden möchten, ist nicht mit Ihrer Bildschirmauflösung kompatibel. Versuchen Sie es erneut von einem Gerät mit einer Auflösung von mehr als 1024 pixel.'
  },
  // component: users
  users: {
    title: 'Benutzer',
    newUser: 'Neuer Benutzer',
    table: {
      username: 'Benutzername',
      firstName: 'Vorname',
      lastName: 'Familienname',
      email: 'E-mail',
      role: 'Rolle',
      company: 'Unternehmen'
    },
    modals: {
      newUser: {
        title: 'Neuer Benutzer'
      },
      editUser: {
        title: 'Benutzer wechseln'
      },
      deleteUser: {
        title: 'Sie werden diesen Benutzer löschen.',
        body: 'Diese Aktion ist unwiderruflich. Möchten Sie weitermachen?'
      },
      user: {
        fields: {
          firstName: 'Vorname',
          lastName: 'Familienname',
          username: 'Benutzername',
          email: 'E-mail',
          company: 'Name des Unternehmens',
          role: 'Benutzer-Rolle',
          password: 'Kennwort',
          repeatPassword: 'Passwort wiederholen'
        }
      }
    },
    filters: {
      company: 'Nach Unternehmen filtern',
      role: 'Nach Rolle filtern'
    }
  },
  // component: forms
  adminForms: {
    filterLabel: 'Nach Formular filtern',
    import: {
      title: 'Einstellungen importieren',
      description:
        'Um Parameter hinzuzufügen oder zu ändern, importieren Sie bitte eine Datei. Wenn der Parameter nicht vorhanden ist, wird er erstellt oder anderweitig geändert.'
    },
    export: {
      title: 'Einstellungen importieren',
      description:
        'Um Parameter hinzuzufügen oder zu ändern, importieren Sie bitte eine Datei. Wenn der Parameter nicht vorhanden ist, wird er erstellt oder anderweitig geändert.'
    },
    toast: {
      success: 'Die Datei wurde erfolgreich verarbeitet',
      error: 'Die Datei konnte nicht verarbeitet werden'
    },
    modal: {
      title: 'Dokument bearbeiten',
      description:
        'Dieser Vorgang kann einige Minuten dauern. Bitte schließen Sie die Seite nicht.'
    }
  },
  // notification
  notifications: {
    error: {
      0: {
        title: 'Error',
        body: 'Laufzeit Fehler'
      },
      400: {
        title: 'Pflichtfeld links',
        body: 'Bitte beachten sie die Informationen links'
      },
      500: {
        title: 'Error',
        body: 'Allgemeiner Fehler'
      },
      409: {
        title: 'Schadennummer-fehler',
        body: 'Die Schadennummer ist bereits vorhanden'
      },
      title: 'Error',
      body: 'Laufzeit Fehler'
    },
    addDamage: {
      title: 'Schaden entstanden',
      body: 'Schaden korrekt erzeugt'
    },
    newSinister: {
      title: 'Neuer Schaden',
      body: 'Schadennummer geändert'
    },
    deleteDamage: {
      title: 'Schaden beseitigt',
      body: 'Der Schaden wurde korrekt gelöscht'
    },
    pdfDamages: {
      title: 'Bericht erstellt',
      body: 'Bericht korrekt erstellt'
    },
    pdfMaterial: {
      title: 'Bericht erstellt',
      body: 'Bericht korrekt erstellt'
    },
    mailPdfMaterial: {
      title: 'E-mail gesendet',
      body: 'E-mail korrekt gesendet',
      error: {
        title: 'E-mail adresse ungültig',
        body: 'Bitte geben sie eine gültige E-mail adresse ein'
      }
    },
    moCalculation: {
      title: 'Preis aktualisiert',
      body: 'Ladebericht läuft'
    },
    changeLanguage: {
      title: 'Sprache ändern',
      body: 'Erneut senden'
    },
    loadSinisterOK: {
      title: 'Anspruch geladen',
      body: 'Informationen hochgeladen'
    },
    loadSinisterKO: {
      title: 'Anspruchsfehler',
      body: 'Fehler beim laden des Schadens'
    },
    paramChanged: {
      title: 'Parameter geändert',
      body: 'Die Tabelle wird automatisch aktualisiert'
    },
    user: {
      isRequired: {
        title: 'Fehlende Felder',
        body: 'Bitte füllen Sie alle Felder korrekt aus'
      },
      isEmail: {
        title: 'Ungültige E-Mail',
        body: `Die eingegebene E-Mail ist ungültig`
      },
      isSamePassword: {
        title: 'Passwort wiederholen',
        body: 'Passwörter stimmen nicht überein'
      },
      createdUser: {
        title: 'Benutzer erstellt',
        body: 'Ansicht wird aktualisiert'
      },
      modifiedUser: {
        title: 'Geänderter Benutzer',
        body: 'Ansicht wird aktualisiert'
      },
      deletedUser: {
        title: 'Benutzer gelöscht',
        body: 'Ansicht wird aktualisiert'
      },
      error: {
        400: {
          title: 'Fehlende Felder',
          body: 'Überprüfen Sie die Formularfelder'
        },
        500: {
          title: 'Fehler',
          body: `Ein Fehler ist aufgetreten`
        },
        409: {
          title: `Identifikationsfehler`,
          body: `Der User existiert`
        }
      }
    }
  },

  // charts view
  charts: {
    mapTitle: 'Geolokalisierung von Ansprüchen',
    sinisterEvolutionTitle: 'Behauptet evolutionär',
    tableTitle: 'Datentabelle',
    noDataAvailable: 'Keine Daten verfügbar',
    barChartDamageSubType: 'Durchschnittliche Kosten der Art der Garantie',
    barChartDamageType: 'Durchschnittliche Kosten der Schadensart',
    barChartCompensationType: 'Kosten nach Art der Entschädigung',
    pieChart: 'Verteilung nach Subtyp des Schadens',
    titleView: 'Instrumententafel',
    downloadData: 'Herunterladen',
    fromDate: 'Von',
    toDate: 'Zu',
    hintFromDate: "Bitte wählen Sie auch die 'Von Datum'",
    hintToDate: "Bitte wählen Sie auch die 'Zu Datum'",
    tableHeadTitle: {
      company: 'Unternehmen',
      userName: 'Nutzername',
      l1: 'Level 1',
      l2: 'Level 2',
      l3: 'Level 3',
      l4: 'Level 4',
      q: 'q',
      averageCost: 'Durchschnittskosten',
      total: 'Gesamt'
    },
    bubbleChartLegend: {
      price: 'Menge',
      damagesCount: 'Frequenz'
    }
  },

  // search view
  search: {
    secondaryRef: 'Alternative Schadennummer',
    status: 'Status',
    gag: 'GAG',
    ren: 'REN',
    asp: 'ASP',
    createdDate: 'Erstellungsdatum',
    updatedDate: 'Neues Datum'
  },

  // tutorials view
  tutorials: {
    title: 'Tutorials',
    subtitle: 'Lernprogramm'
  },

  // Biens obiliers View
  biensMobiliers: {
    title: 'Bewegliches Eigentum',
    searchEmpty: {
      search: 'Ihre Suche',
      notFound: 'Keine Ergebnisse gefunden'
    },
    text:
      'Verwenden Sie die Suchmaschine oder navigieren Sie durch das Seitenmenü, um das gesuchte Element zu finden. Sie können auch zwischen unseren häufigsten Kategorien wählen'
  },

  // dashboard view
  dashboard: {
    GAG: {
      title: 'Knebel und Teleauswertungen',
      downloadData: 'Daten herunterladen',
      filters: {
        date: 'Zeitraum',
        startDate: 'Startdatum',
        endDate: 'Endtermin',
        orderBy: 'Sortiere nach',
        orderByOptions: {
          tmo: 'TMO',
          totalGAG: 'Gesamt DIY',
          sinisterTotal: 'Gesamt-Televal',
          conversion: 'Wandlung'
        }
      },
      kpis: {
        gag: 'GAG erkannte',
        TE: 'Fernsehauftritte',
        gagWeek: 'Get mit 1 GAG / Woche',
        gagSans: 'Geste ohne GAG'
      },
      table: {
        headers: {
          manager: 'Administrator',
          conversion: 'Wandlung',
          weeks: 'Wochen',
          evolution: 'Evolution',
          total: 'Gesamt',
          totalGAG: 'Gesamt-DIY',
          totalTE: 'Gesamt-Televal',
          TMO: 'TMO'
        }
      }
    }
  },

  // common
  common: {
    surface: 'Oberfläche',
    line: 'Lineal',
    distance: 'Entfernung',
    actualCalc: 'Berechnung läuft',
    selectOnTheMap: 'Auf der Karte messen',
    mapAction: 'Auf der Karte messen',
    mapActionLine: 'Auf der Karte messen',
    min: 'Minimum',
    max: 'Maximal',
    recommended: 'Empfohlen',
    standard: 'Standard',
    email: 'E-mail',
    search: 'Suche',
    results: 'Ergebnisse',
    noresults: {
      short: 'Kein Ergebnis',
      long: 'Es gibt kein Ergebnis für ihre Suche'
    },
    true: 'Ja',
    false: 'Nein',
    noOptions: 'Es gibt keine Option',
    noSelected: 'Keine Auswahl',
    agentView: 'Versicherungsagent Ansicht',
    managerView: 'Verwalter Ansicht',
    unit: '0 Einheiten | x {count} Einheit | x {count} Einheiten'
  },
  empties: {
    noResults: {
      title: 'Kein Ergebnis',
      descr: 'Verwenden sie andere Suchparameter'
    }
  },
  // Area component
  areaMeasurement: {
    damageArea: 'Schadensbereich',
    measurementTipe: 'In Quadratmetern',
    heightMeasurement: 'Höhe',
    widhtMeasurement: 'Breite'
  }
}
